/**
 * User: Rob Richard
 * Date: 8/21/14
 * Time: 11:07 AM
 */

'use strict';

var $ = require('dibs-jquery-shim');
var scrollHelper = require('../utils/commonjs/scrollHelper');

/**
 * extend this onto a Validation form view to make it compatible with .com forms and validations
 * @type {{showValidationError: Function, hideValidationError: Function}}
 */
module.exports = {
    showValidationError: function (event, $input, obj) {
        var $field;
        var $err;
        var $errDiv;
        var dataTn;
        if ($input.attr('data-tn')) {
            dataTn = $input.attr('data-tn') + '-validation-error';
        } else {
            dataTn = 'validation-error-unknown-source';
        }


        if ($input) {
            $field = $input.parents('.com-form-input-wrapper').first();
            $err = $field.find('.err-message');
            if ($err.length) {
                $err.addClass('active').html(obj.message);
                $err.attr('data-tn', dataTn);

            } else {
                $errDiv = $('<div>').addClass('err-message active').attr('data-tn', dataTn).html(obj.message);
                $field.append($errDiv);
            }
            $input.addClass('err-message-field');
        }
    },
    hideValidationError: function (event, $input) {
        var $field;
        if ($input) {
            $field = $input.parents('.com-form-input-wrapper').first();
            $field.find('.err-message').removeClass('active').empty();
            $input.removeClass('err-message-field');
        }
    },
    scrollToFirstError: function ($err, offset) {
        var $field = $err.parent('.com-form-input-wrapper');

        offset = Math.abs(offset || 20) * -1;

        if (!$field.length) {
            return;
        }
        scrollHelper.scrollElToTop($field, offset);
    }
};



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/models/formview-validation.js
// module id = 1006
// module chunks = 4 7 12 36